import React from 'react';
import { IOldIconProps } from './type';

const FlagFR: React.FC<IOldIconProps> = ({ width, height, ...props }) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 34.01575 34.01575"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.flagfr-1{fill:#fff;}.flagfr-2{fill:#2e50a2;}.flagfr-3{fill:#ea3223;}.flagfr-4,.flagfr-5{fill:none;stroke:#050505;stroke-miterlimit:10;stroke-width:1.35203px;}.flagfr-5{stroke-linecap:round;}'
          }
        </style>
      </defs>
      <path
        className="flagfr-1"
        d="M18.531,6.814c.08764.78874,2.01568,13.40865,2.01568,13.40865l-7.09321.69369L11.55618,7.98182Z"
      />
      <path
        className="flagfr-2"
        d="M11.95815,7.42742c.08764.78875,2.01568,13.40866,2.01568,13.40866l-7.09321.69369L4.9833,8.59528Z"
      />
      <path
        className="flagfr-3"
        d="M25.45445,5.14883c.08763.78874,2.01568,13.40865,2.01568,13.40865l-7.09322.69369L18.4796,6.31669Z"
      />
      <rect
        className="flagfr-4"
        x={5.82205}
        y={7.01941}
        width={20.76252}
        height={13.0729}
        transform="translate(-1.79585 2.49517) rotate(-8.345)"
      />
      <line
        className="flagfr-5"
        x1={4.99862}
        y1={8.71381}
        x2={8.16969}
        y2={30.01498}
      />
    </svg>
  );
};

export default FlagFR;
